import NotificationReminders from './NotificationReminders';

export default NotificationReminders;



// WEBPACK FOOTER //
// ./src/views/containers/NotificationReminders/index.js